import {
  DeleteOverrideResponse,
  StockHistoricalPricesResponse,
  StockOverrideCreateInput,
  StockOverrideListResponse,
  StockOverrideMutationResponse,
  StockOverrideUpdateInput,
} from "../types/historicalOverrides";
import httpService from "./httpService";

/**
 * Service for Historical Price Overrides admin APIs (JWT auth, /v3/admin).
 * Scope: stock overrides only for now.
 */
class HistoricalOverridesService {
  private readonly baseUrl = "/v3/admin";

  async listStockOverrides(params: {
    conId?: number;
    page?: number;
    pageSize?: number;
    isActive?: boolean;
  }): Promise<StockOverrideListResponse> {
    const qs = new URLSearchParams();
    if (params.conId !== undefined) qs.set("conId", String(params.conId));
    if (params.page !== undefined) qs.set("page", String(params.page));
    if (params.pageSize !== undefined) qs.set("pageSize", String(params.pageSize));
    if (params.isActive !== undefined) qs.set("isActive", String(params.isActive));

    const response = await httpService.get<StockOverrideListResponse>(
      `${this.baseUrl}/stocks/overrides?${qs.toString()}`
    );
    return response.data;
  }

  async createStockOverride(
    input: StockOverrideCreateInput
  ): Promise<StockOverrideMutationResponse> {
    const response = await httpService.post<StockOverrideMutationResponse>(
      `${this.baseUrl}/stocks/overrides`,
      input
    );
    return response.data;
  }

  async updateStockOverride(
    id: number,
    input: StockOverrideUpdateInput
  ): Promise<StockOverrideMutationResponse> {
    const response = await httpService.put<StockOverrideMutationResponse>(
      `${this.baseUrl}/stocks/overrides/${id}`,
      input
    );
    return response.data;
  }

  async deleteStockOverride(id: number): Promise<DeleteOverrideResponse> {
    const response = await httpService.delete<DeleteOverrideResponse>(
      `${this.baseUrl}/stocks/overrides/${id}`
    );
    return response.data;
  }

  async getStockPrices(params: {
    conId: number;
    from?: string;
    to?: string;
    pageNumber?: number;
  }): Promise<StockHistoricalPricesResponse> {
    const qs = new URLSearchParams();
    qs.set("conId", String(params.conId));
    if (params.from) qs.set("from", params.from);
    if (params.to) qs.set("to", params.to);
    if (params.pageNumber !== undefined) qs.set("pageNumber", String(params.pageNumber));

    const response = await httpService.get<StockHistoricalPricesResponse>(
      `${this.baseUrl}/stocks/prices?${qs.toString()}`
    );
    return response.data;
  }
}

export const historicalOverridesService = new HistoricalOverridesService();
export default historicalOverridesService;
